/* global google */
import {
  TerraDraw,
  TerraDrawPolyLineMode,
  TerraDrawSelectMode,
} from "terra-draw";
import { TerraDrawGoogleMapsAdapter } from "terra-draw-google-maps-adapter";
import Colors from "../../../../themes/Colors";

// Areas are drawn click-by-click as a polyline and closed into a polygon on
// finish, so a finished area keeps DRAW_MODE as its feature mode — which is the
// key the select mode flags below are looked up by.
export const DRAW_MODE = "polyline";
export const SELECT_MODE = "select";
// Built into every TerraDraw instance: renders the features, ignores every
// interaction.
export const STATIC_MODE = "static";

// Styling for the polyline-as-area drawing mode: the line and the enclosed
// area (rendered as the line is drawn) both use the brand primary color.
export const polyLineDrawStyles = {
  lineStringColor: Colors.primary,
  lineStringWidth: 2,
  polygonFillColor: Colors.primary,
  polygonFillOpacity: 0.5,
  polygonOutlineColor: Colors.primary,
  polygonOutlineWidth: 2,
};

// Highlight for the area picked in select mode, so it is obvious which one
// `Supr` is about to delete.
export const selectStyles = {
  selectedPolygonColor: Colors.atention,
  selectedPolygonFillOpacity: 0.4,
  selectedPolygonOutlineColor: Colors.atention,
  selectedPolygonOutlineWidth: 3,
};

// `Supr` deletes the picked area: that is the select mode's own default
// keyEvents.delete ("Delete"), handled on keyup while the map div holds focus.
// Areas are pickable and deletable but never draggable nor reshapeable: a drawn
// area must keep matching the screens it added to the cart. A mode with no
// `feature` flag entry is not selectable at all, hence the DRAW_MODE key.
const selectModeFlags = {
  [DRAW_MODE]: {
    feature: {
      draggable: false,
      coordinates: {
        draggable: false,
        midpoints: false,
        deletable: false,
      },
    },
  },
};

// Build a TerraDraw instance bound to the given raw google.maps.Map. Replaces
// the deprecated google.maps DrawingManager.
export const createTerraDraw = (rawMap) =>
  new TerraDraw({
    adapter: new TerraDrawGoogleMapsAdapter({
      map: rawMap,
      lib: google.maps,
    }),
    modes: [
      new TerraDrawPolyLineMode({ styles: polyLineDrawStyles }),
      new TerraDrawSelectMode({
        styles: selectStyles,
        flags: selectModeFlags,
      }),
    ],
  });
